import React from 'react';
import { X } from 'lucide-react';

const DISMISSAL_REASONS = [
  { value: 'wrong_function', label: 'Wrong function' },
  { value: 'wrong_seniority', label: 'Wrong seniority' },
  { value: 'wrong_industry', label: 'Wrong industry' },
  { value: 'wrong_location', label: 'Wrong location' },
  { value: 'compensation_mismatch', label: 'Compensation mismatch' },
  { value: 'other', label: 'Other' },
];

export default function DismissalReasonPicker({ onSelect, onSkip }) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-sm text-gray-900">Why isn't this a fit?</h3>
          <button onClick={onSkip} className="text-gray-400 hover:text-gray-600" aria-label="Skip">
            <X size={18} />
          </button>
        </div>
        <p className="text-xs text-gray-500 mb-3">Help us show you better matches</p>
        <div className="space-y-1.5">
          {DISMISSAL_REASONS.map(reason => (
            <button
              key={reason.value}
              onClick={() => onSelect(reason.value)}
              className="w-full text-left py-2 px-3 text-sm text-gray-700 hover:bg-gray-50 rounded-lg border border-gray-200 hover:border-vouch-teal transition-colors"
            >
              {reason.label}
            </button>
          ))}
        </div>
        <button onClick={onSkip} className="w-full mt-3 py-2 text-gray-400 text-xs hover:text-gray-600">
          Skip
        </button>
      </div>
    </div>
  );
}
